import { useEffect, useState } from 'react';
import { getData } from '../utils/apiCalls';
import { duplicateArrayElements } from '../utils/funcs';

export const RibbonAdds = () => {
    const [data, setData] = useState(null)

    useEffect(() => {
        const timer = setTimeout(() =>
            getData(`https://youngstartup.io/api/cwebsite/get_current_event_w_ribbon`)
                .then(res => {
                    setData(res)
                }), 1500)
        return () => clearTimeout(timer)
    }, [])

    if (!data || !data.ribbon_active) return <></>

    return (
        <div className='ribbon-adds'>
            <div className='ribbon-inner'>
                {duplicateArrayElements(data.ribbon_messages, 20).concat(duplicateArrayElements(data.ribbon_messages, 20)).map((i, idx) => (
                    <h1 key={idx} dangerouslySetInnerHTML={{ __html: i.message }}></h1>
                ))}
            </div>
        </div>
    )
}


